import axios from "axios";
import { baseUrl } from "../App";

export const fetchUserLeaderboard = async (token) => {
  const res = await axios.get(`${baseUrl}/api/participantProfile/user_leaderboard/?portal=15`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}